/* eslint-disable */
import {
    userIint,
    getInfo,
    sendMsg,
    getTicketTypeInfoList,
    getTicketDeployTemplateList,
    getZoneList
} from '../services/app'
import Loading from '../components/Loading'
import {
    getHeaderLanguage,
    headersLanguageKey,
    color2Rgba
} from '../utils/index'
import strEscape from '../utils/strEscape'

function change(arr) {
    arr.forEach((o) => {
        if (o.nodeFlag) {
            change(o.items)
        }
        o.title = o.typeName
        o.value = o.typeId
        if (o.items) {
            o.disabled = true
            o.children = o.items
        }
    })
}

export const ids = [
    'userId',
    'partnerId',
    'tel',
    'email',
    'paramUnionId',
    'wxExternalUserIds',
    'wxOpenIds',
    'faceBookIds',
    'instagramIds',
    'whatsappIds',
    'lineIds',
    'telegramIds',
    'discordIds',
    'shopifyShopId',
]

export const getIdsObj = (query = {}, ids = []) => {
    let obj = {}
    if (Object.prototype.toString.call(query) === '[object Object]') {
        Object.keys(query).forEach((item) => {
            if (ids.includes(item)) {
                obj[item] = query[item]
            }
        })
    }

    return obj
}

// function randomWord () {
//     let str = "",
//         arr = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f'];
//     let id;
//     for(let i = 0 ; i < 32 ; i++){
//         id = parseInt(Math.random()* (arr.length - 1));
//         str += arr[id];
//     }
//     return str;
// }
export default {
    namespace: 'app',
    state: {
        region: 0,
        timeZoneDict: [], // 时区
        sbumitFlag: true,
        ids: {},
        item: {},
        fieldConfig: [],
        ticketTypeList: [],
        // templateList: [],
        showType: '',
        deployConfigInfo: {
            item: {
                msgTitle: '',
                listTitle: '',
                detailTitle: ''
            }
        },
        isTemplate: true,
        cusParamsField: [],
        verifyType: undefined,
        queryParams: {}
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        },
        idsInfo(state, { payload }) {
            return { ...state, ids: payload }
        },
        configInfo(state, { payload }) {
            return { ...state, deployConfigInfo: payload }
        },
        templateInfo(state, { payload }) {
            return { ...state, item: payload }
        },
        fieldInfo(state, { payload }) {
            return { ...state, fieldConfig: payload }
        },
        confirmInfo(state, { payload }) {
            return { ...state, sbumitFlag: payload }
        },
        changeItem(state, { payload }) {
            return { ...state, showType: payload }
        },
        changeVerifyType(state, { payload }) {
            return { ...state, verifyType: payload }
        }
    },
    effects: {
        *getTemplate({ payload }, { call, put }) {
            Loading.open()

            const info = yield call(userIint, {
                sysNum: payload.sysNum,
                partnerId: window.urlObject.partnerid || '',
                agid: !window.urlObject.partnerid
                    ? window.urlObject.uid || ''
                    : '',
                ticketFlag: 1,
                source: window.urlObject.source || '',
                customerId: window.urlObject.customerId || '',
                ...getIdsObj(payload, ids),

            })
            const uid = info.uid
            window.urlObject.uid = uid
            yield put({
                type: 'idsInfo',
                payload: {
                    uid: uid,
                    companyId: info.pid
                }
            })

            const deployConfigInfo = yield call(getTicketDeployTemplateList, {
                deployId: payload.deployId,
                sysNum: payload.sysNum || payload.sysnum
            })
            document.title = deployConfigInfo?.item?.deployName
            yield put({
                type: 'update',
                payload: {
                    region: +(deployConfigInfo?.item?.region || '0') || 0
                    // region: 1
                }
            })
            // changeTitle(deployConfigInfo.item.deployName)
            yield put({
                type: 'configInfo',
                payload: deployConfigInfo
            })
            if (window.urlObject.params) {
                yield put({
                    type: 'getCusParams',
                    payload: {
                        uid: window.urlObject.uid
                    }
                })
            }

            let showType = 1

            if (deployConfigInfo?.item?.historyTicketFlag) {
                if (window.urlObject.customerId) {
                    showType = 3
                    if (window.urlObject.ticketId) {
                        showType = 4
                        yield put({
                            type: 'leaveMsg/getLeaveMsgDetail',
                            payload: {
                                uid,
                                param: {
                                    companyId: payload.sysNum,
                                    ticketId: window.urlObject.ticketId,
                                    showType
                                }
                            }
                        })
                        yield put({
                            type: 'leaveMsg/update',
                            payload: {
                                scoreData: [],
                                solvedData: -1,
                                star: '',
                                tag: [],
                                tagName: [],
                                text: ''
                            }
                        })
                    }
                }
            }

            if ((deployConfigInfo.items || []).length === 1) {
                yield put({
                    type: 'update',
                    payload: {
                        isTemplate: false
                    }
                })

                if (showType === 1) {
                    yield put({
                        type: 'getList',
                        payload: {
                            uid: window.urlObject.uid,
                            companyId: window.urlObject.sysNum,
                            templateId: deployConfigInfo.items[0].templateId
                        }
                    })
                }
            } else {
                // shotype为初始值时，说明链接中没有客户id与工单id
                if (showType === 1) {
                    showType = 0
                }
                yield put({
                    type: 'update',
                    payload: {
                        isTemplate: true
                    }
                })
            }

            //
            if (payload?.isOnlyShowList === '1') {
                showType = 3
            }

            // 为 4 时进详情，需要等数据返回后再进入，在leaveMsg/getLeaveMsgDetail中有处理
            if (showType !== 4) {
                yield put({
                    type: 'changeItem',
                    payload: showType
                })
            }

            const lanConfig = deployConfigInfo.item?.language
            const themeColor = deployConfigInfo.item?.themeColor
            document.body.style.setProperty('--theme-color', themeColor)
            document.body.style.setProperty(
                '--theme-color-10',
                color2Rgba(themeColor, 0.1)
            )

            // 预览页面语言替换
            if (window.parent.length > 0) {
                window.parent.postMessage(
                    {
                        type: 'zhichi-ticketclient-language',
                        data: payload.locale || lanConfig
                    },
                    '*'
                )
            }
            const locale = payload.locale || lanConfig
            yield put({
                type: 'locale/update',
                payload: { locale }
            })
            // 设置语言 - 兼容语言命名
            const language = getHeaderLanguage(locale)
            window[headersLanguageKey] = language
            yield put({
                type: 'leaveMsg/getTicketStatusInfoList',
                payload: { language }
            })
            const zoneInfo = yield call(getZoneList, { language })
            yield put({
                type: 'update',
                payload: { timeZoneDict: zoneInfo.item || [] }
            })
            setTimeout(() => {
                Loading.hide()
            }, 500)
        },
        *getList({ payload }, { call, put }) {
            Loading.open()
            const uid = payload.uid
            const templateConfig = yield call(getInfo, {
                uid: uid,
                url: 'basic-config-service/msg/getMsgTemplateConfig',
                method: 'get',
                param: '{"templateId":"' + payload.templateId + '"}'
            })
            yield put({ type: 'templateInfo', payload: templateConfig.item })
            const fieldConfig = yield call(getInfo, {
                uid: uid,
                url: 'basic-config-service/msg/getTemplateFieldsInfo',
                method: 'get',
                param:
                    '{"operateType":3,"openFlag":1,"regionalFlag": "1","templateId":"' +
                    payload.templateId +
                    '"}'
            })
            const list = fieldConfig.items.filter(
                (item) => item.cusFieldConfig.operateType !== 31
            )
            yield put({ type: 'fieldInfo', payload: list })
            if (templateConfig.item.ticketTypeFlag === 1) {
                const arr = yield call(getTicketTypeInfoList, {
                    uid: uid,
                    url: '/ws-service/queryTicketTypeInfoList/4',
                    method: 'get'
                })
                change(arr.items)
                yield put({
                    type: 'update',
                    payload: { ticketTypeList: arr.items }
                })
            }
            // yield put({ type: 'changeItem', payload: payload.showType });
            setTimeout(() => {
                Loading.hide()
            }, 500)
        },
        *getCusParams({ payload }, { call, put }) {
            const data = yield call(getInfo, {
                uid: payload.uid,
                url: 'ws-service/getTicketPartnerFields/4',
                method: 'get'
            })
            let params = null
            let cusParamsField = []
            try {
                const str = decodeURIComponent(window.urlObject.params)
                if (typeof JSON.parse(str) === 'object') {
                    params = JSON.parse(str)
                }
            } catch (e) {
                alert('JSON格式错误!')
                params = null
            }
            data.items.forEach((i) => {
                for (let key in params) {
                    if (i.fieldParams === key) {
                        cusParamsField.push({
                            id: i.fieldId,
                            value: params[key],
                            fieldName: i.fieldName,
                            params: i.fieldParams
                        })
                    }
                }
            })
            yield put({
                type: 'update',
                payload: {
                    cusParamsField
                }
            })
        },
        *postMsg({ payload, callback }, { call, select }) {
            const { queryParams } = yield select(({ app }) => app)
            let params = payload.data
            // params.ticketContent = strEscape(params.ticketContent)
            const data = yield call(sendMsg, {
                ...params,
                partnerId: window.urlObject.partnerid || '',
                sysNum: window.urlObject.sysNum || '',
                groupId: window.urlObject.groupId || '',
                ...getIdsObj(queryParams, ids)
            })
            if (data.retCode === '000000') {
                callback(data)
            } else {
                callback(data)
                // alert(data.retMsg);
            }
        }
    },
    subscriptions: {
        setup({ dispatch }) {
            init(window.location.search, dispatch)
        }
    }
}

function init(link, dispatch) {
    let q = {}
    link.replace(/([^?&=]+)=([^&]+)/g, (_, k, v) => (q[k] = v))
    if (q?.locale) {
        if (!q?.locale) {
            q.locale = 'zh_CN'
        }
    }
    dispatch({
        type: 'getTemplate',
        payload: q
    })
    dispatch({
        type: 'update',
        payload: {
            queryParams: q
        }
    })
}
